export const buildBackendUrl = (origin: string | undefined, path: string) => {
    const normalizedOrigin = (origin || '').replace(/\/+$/, '');
    return `${normalizedOrigin}${path.startsWith('/') ? path : `/${path}`}`;
};

export const backendUrl = (path: string) => buildBackendUrl(import.meta.env.VITE_CDM_API as string | undefined, path);

const keys = {
    API_BASE: backendUrl('/api'),
    ENV: import.meta.env.MODE,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
    PUSHER_KEY: import.meta.env.VITE_PUSHER_KEY || import.meta.env.VITE_EXPORT_KEY,
    PUSHER_CLUSTER: import.meta.env.VITE_PUSHER_CLUSTER || 'eu',
};

export default keys;
